import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import { useTranslate } from "hooks";
import { Checkbox, Spinner } from "components";
import { topologyConfig } from "components/Topology/configs/topologyConfig";
import {
  useIsFetching,
  useSelectedPasteItem,
  useWizardActions,
} from "stores/wizardStore";
import s from "../../topology.module.scss";

export const PastButton = React.memo(({ topologyParentId, famGroupIdx }) => {
  const translate = useTranslate();
  const isActionFetching = useIsFetching();
  const { handlePasteAction } = useWizardActions();
  const selectedPasteItem = useSelectedPasteItem();
  const { nodeWidth, nodeHeight } = topologyConfig;

  const isChecked = useMemo(
    () => selectedPasteItem?.has(topologyParentId),
    [selectedPasteItem, topologyParentId],
  );

  const selectText = useMemo(
    () =>
      isChecked
        ? translate("WIZARD_NODE_SELECTED")
        : translate("WIZARD_NODE_SELECT"),
    [isChecked, translate],
  );

  const handleClick = useCallback(
    () => handlePasteAction(topologyParentId, famGroupIdx),
    [famGroupIdx, handlePasteAction, topologyParentId],
  );

  return (
    <div
      className="position-relative cursor-pointer"
      data-test-parentid={`pastBtn-${topologyParentId}`}
      style={{ width: nodeWidth, height: nodeHeight }}
      onClick={handleClick}
    >
      <div
        className={cx(
          "d-flex bg-blue-100 h-100 w-100 align-items-center gap-2_5 body-secondary bg-opacity-50 font16",
          s.pastBorder,
        )}
      >
        <div
          className={cx("bg-white w-20 h-100")}
          style={{
            width: nodeHeight,
          }}
        />
        <div className={cx("text-blue-300 fw-bold ")}>{selectText}</div>
        <div className="ms-auto px-2_5">
          {isActionFetching && isChecked ? (
            <Spinner size="xs" classNames="text-white" />
          ) : (
            <Checkbox
              topologyParentId={topologyParentId}
              checked={isChecked}
              classNames="border border-info"
              readOnly
              data-test-toplogyparentid={topologyParentId}
              data-testid={`checkbox-${topologyParentId}`}
              onChange={handleClick}
            />
          )}
        </div>
      </div>
    </div>
  );
});
